// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__12x0k","signatureButtonsRight":"ModalSign_signatureButtonsRight__2GMn1"};